import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const CheckmarkIcon = ({ color = '#0D84FE', size = '20', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 283.46 283.46"
    width={size}
    height={size}
    {...props}
  >
    <path
      fill={color}
      d="M253.41 56.125c.407-.534.786-1.09 1.116-1.683l.396-.6-.072-.044c.88-1.802 1.387-3.82 1.387-5.96 0-7.513-6.094-13.607-13.608-13.607-4.4 0-8.303 2.1-10.79 5.34L112.75 190.602 55.275 141.02c-.75-.792-1.58-1.51-2.477-2.14l-.077-.064-.005.004c-2.623-1.808-5.798-2.874-9.226-2.874-8.985 0-16.27 7.284-16.27 16.267 0 4.08 1.512 7.798 3.992 10.653l-.01.01 72.32 79.83c2.967 3.954 7.68 6.523 13.004 6.523 5.322 0 10.034-2.57 13.002-6.522h.01l.076-.114c.318-.43.614-.877.89-1.34l122.903-185.13z"
    />
  </svg>
);

CheckmarkIcon.propTypes = propTypes;

export default CheckmarkIcon;
